import { useQuery } from '@tanstack/react-query';
import { AppVersionService, AppVersionConfig } from '@/services/appVersion.service';

export const useAppVersionConfig = () => {
  const { data, isLoading, error } = useQuery<AppVersionConfig>({
    queryKey: ['app-version-config'],
    queryFn: () => AppVersionService.getAppVersion(),
    staleTime: 60 * 60 * 1000, // 1 hour — this rarely changes
    retry: 1,
  });

  return { config: data, isLoading, error };
};
